import { graphql } from "react-relay";

export const offer_lesson_block_to_new_pupil = graphql`
  mutation OfferLessonBlockToNewPupilMutation($input: OfferLessonBlockToNewPupilInput!) {
    offerLessonBlockToNewPupil(input: $input) {
      success
      errors
      lessonBlock {
        id
        enrolmentOffers(archived: false, offerAccepted: false) {
          edges {
            node {
              id
              enrolment {
                id
                pupilFirstName
                pupilLastName
              }
            }
          }
        }
      }
      enrolment {
        id
        status
        lastOfferedTimestamp
        offers(archived: false, offerAccepted: false) {
          edges {
            node {
              id
              enrolment {
                id
                pupilFirstName
                pupilLastName
              }
            }
          }
        }
      }
      archivedEnrolmentOffers {
        id
        archived
        archivedTimestamp
        enrolment {
          id
          status
        }
      }
    }
  }
`;
